(function () {
    function initMixMatch() {
        // Find container and check if already initialized
        const container = document.querySelector('.mix-match-container');
        if (!container) return;
        if (container.hasAttribute('data-initialized')) return;
        container.setAttribute('data-initialized', 'true');

        const bundleState = {};
        const productsContainer = document.querySelector('.mix-match-products');

        if (!productsContainer) return;

        const bundleItemsContainer = document.querySelector('.mix-match-bundle-items');
        const subtotalEl = document.querySelector('.js-subtotal');
        const eligibleRow = document.querySelector('.js-eligible-row');
        const eligibleSubtotalEl = document.querySelector('.js-eligible-subtotal');
        const excludedRow = document.querySelector('.js-excluded-row');
        const excludedSubtotalEl = document.querySelector('.js-excluded-subtotal');
        const subtotalRow = document.querySelector('.js-subtotal-row');

        const discountEl = document.querySelector('.js-discount');
        const totalEl = document.querySelector('.js-bundle-total');
        const checkoutBtn = document.querySelector('.js-checkout-btn');
        const discountMsg = document.querySelector('.js-discount-msg');
        const emptyMsg = document.querySelector('.empty-bundle-msg');
        const purchaseOptions = document.querySelectorAll('.js-purchase-option');
        const discountRow = document.querySelector('.discount-row');
        const progressBar = document.querySelector('.js-progress-bar');
        const freeShippingMsg = document.querySelector('.js-free-shipping-msg');
        const mobileTotal = document.querySelector('.js-mobile-total');
        const mobileDiscount = document.querySelector('.js-mobile-discount');
        const mobileShipping = document.querySelector('.js-mobile-shipping');

        const currencySymbol = container.getAttribute('data-currency-symbol') || '€';
        const subDiscountPercent = parseInt(container.getAttribute('data-subscription-discount-percent'), 10) || 30;
        const tier1Qty = parseInt(container.getAttribute('data-discount-tier-1-qty'), 10) || 0;
        const tier1Percent = parseInt(container.getAttribute('data-discount-tier-1-percent'), 10) || 0;
        const tier2Qty = parseInt(container.getAttribute('data-discount-tier-2-qty'), 10) || 0;
        const tier2Percent = parseInt(container.getAttribute('data-discount-tier-2-percent'), 10) || 0;
        const freeShippingThreshold = parseInt(container.getAttribute('data-free-shipping-threshold'), 10) || 0;

        let isSubscription = true;

        // Helper to format money (simple version, assumes currency format)
        function formatMoney(cents) {
            return (cents / 100).toFixed(2) + ' ' + currencySymbol;
        }

        function updateUI() {
            // Update Product Cards
            document.querySelectorAll('.mix-match-actions').forEach(actionEl => {
                const variantId = actionEl.getAttribute('data-variant-id');
                const qtyVal = actionEl.querySelector('.mix-match-qty-val');

                if (!qtyVal) return;

                const qty = (bundleState[variantId] && bundleState[variantId].qty > 0) ? bundleState[variantId].qty : 0;
                qtyVal.textContent = qty;

                // Optional: visual state for zero qty
                const pill = actionEl.querySelector('.mix-match-qty-pill');
                if (pill) {
                    if (qty > 0) {
                        pill.classList.add('active');
                    } else {
                        pill.classList.remove('active');
                    }
                }
            });

            // Update Sidebar Items
            if (bundleItemsContainer) {
                bundleItemsContainer.innerHTML = '';
            }
            let totalCents = 0;
            let totalCount = 0;
            let eligibleCents = 0;
            let eligibleCount = 0;

            const items = Object.values(bundleState);

            if (emptyMsg) {
                if (items.length === 0) {
                    emptyMsg.style.display = 'block';
                } else {
                    emptyMsg.style.display = 'none';
                }
            }

            if (bundleItemsContainer && items.length > 0) {
                items.forEach(item => {
                    if (item.qty > 0) {
                        totalCount += item.qty;
                        totalCents += item.price * item.qty;
                        if (!item.excluded) {
                            eligibleCount += item.qty;
                            eligibleCents += item.price * item.qty;
                        }

                        const itemEl = document.createElement('div');
                        itemEl.className = 'mix-match-bundle-item';
                        itemEl.innerHTML = `
                <div class="mix-match-bundle-item-content">
                    <div class="mix-match-bundle-item-icon" style="${item.iconBg ? 'background-color:' + item.iconBg : ''}">
                        ${item.iconHtml || `<img src="${item.image}" alt="" style="width:100%;height:100%;object-fit:cover;">`}
                    </div>
                    <div class="mix-match-bundle-item-details">
                        <div class="mix-match-bundle-item-title">${item.title}</div>
                        <div class="mix-match-bundle-item-subtitle">${item.qty} x ${formatMoney(item.price)}</div>
                    </div>
                </div>
                <div class="mix-match-bundle-item-price">${formatMoney(item.price * item.qty)}</div>
                <button type="button" class="mix-match-bundle-item-remove js-remove-sidebar-item" data-variant-id="${item.variantId}" aria-label="Remove">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>
            `;
                        bundleItemsContainer.appendChild(itemEl);
                    }
                });
            }

            // Calculate Discounts & Totals
            let discount = 0;

            if (isSubscription) {
                discount = eligibleCents * (subDiscountPercent / 100);
                if (discountMsg) {
                    if (discount > 0) {
                        discountMsg.style.display = 'block';
                        discountMsg.textContent = `Συνδρομή ενεργή! Κερδίζετε ${subDiscountPercent}% (${formatMoney(discount)})`;
                    } else {
                        discountMsg.style.display = 'none';
                    }
                }
            } else {
                let activeTierPercent = 0;

                if (tier2Qty > 0 && eligibleCount >= tier2Qty) {
                    activeTierPercent = tier2Percent;
                } else if (tier1Qty > 0 && eligibleCount >= tier1Qty) {
                    activeTierPercent = tier1Percent;
                }

                if (discountMsg) {
                    if (activeTierPercent > 0) {
                        discount = eligibleCents * (activeTierPercent / 100);
                        discountMsg.style.display = 'block';
                        discountMsg.textContent = `Συγχαρητήρια! Κερδίζετε ${activeTierPercent}% (${formatMoney(discount)})`;
                    } else if (tier1Qty > 0) {
                        const nextTierQty = eligibleCount < tier1Qty ? tier1Qty : tier2Qty;
                        const nextTierPercent = eligibleCount < tier1Qty ? tier1Percent : tier2Percent;

                        if (nextTierQty) {
                            const remaining = Math.max(nextTierQty - eligibleCount, 0);
                            discountMsg.style.display = 'block';
                            const itemLabel = remaining === 1 ? 'προϊόν' : 'προϊόντα';
                            discountMsg.textContent = `Προσθέστε ${remaining} ακόμη ${itemLabel} για να κερδίσετε ${nextTierPercent}%`;
                        } else {
                            discountMsg.style.display = 'none';
                        }
                    } else {
                        discountMsg.style.display = 'none';
                    }
                }
            }

            // Update progress bar
            if (progressBar) {
                if (isSubscription || (!tier1Qty && !tier2Qty)) {
                    progressBar.style.width = '0%';
                } else {
                    let targetQty = 0;
                    if (eligibleCount < tier1Qty) {
                        targetQty = tier1Qty;
                    } else if (tier2Qty) {
                        if (eligibleCount < tier2Qty) {
                            targetQty = tier2Qty;
                        } else {
                            targetQty = tier2Qty;
                        }
                    } else {
                        targetQty = tier1Qty;
                    }

                    const progress = targetQty ? Math.min((eligibleCount / targetQty) * 100, 100) : 0;
                    progressBar.style.width = `${progress}%`;
                }
            }

            const finalTotal = totalCents - discount;
            const excludedCents = totalCents - eligibleCents;

            // Update Summary Rows
            if (eligibleRow && eligibleSubtotalEl) {
                if (eligibleCents > 0) {
                    eligibleRow.classList.remove('hidden');
                    eligibleSubtotalEl.textContent = formatMoney(eligibleCents);
                } else {
                    eligibleRow.classList.add('hidden');
                }
            }

            if (excludedRow && excludedSubtotalEl) {
                if (excludedCents > 0) {
                    excludedRow.classList.remove('hidden');
                    excludedSubtotalEl.textContent = formatMoney(excludedCents);
                } else {
                    excludedRow.classList.add('hidden');
                }
            }

            if (subtotalRow) {
                subtotalRow.classList.add('hidden');
            }
            if (subtotalEl) subtotalEl.textContent = formatMoney(totalCents);

            if (discountRow && discountEl) {
                if (discount > 0) {
                    discountRow.classList.remove('hidden');
                    discountEl.textContent = '-' + formatMoney(discount);
                } else {
                    discountRow.classList.add('hidden');
                }
            }

            if (totalEl) totalEl.textContent = formatMoney(finalTotal);

            if (checkoutBtn) {
                checkoutBtn.disabled = totalCount === 0;
            }

            if (mobileTotal) {
                mobileTotal.textContent = formatMoney(finalTotal);
            }

            const mobileProgressBar = document.querySelector('.js-mobile-progress-bar');
            if (mobileProgressBar) {
                if (isSubscription || (!tier1Qty && !tier2Qty)) {
                    mobileProgressBar.style.width = '0%';
                } else {
                    let targetQty = 0;
                    if (eligibleCount < tier1Qty) {
                        targetQty = tier1Qty;
                    } else if (tier2Qty) {
                        if (eligibleCount < tier2Qty) {
                            targetQty = tier2Qty;
                        } else {
                            targetQty = tier2Qty;
                        }
                    } else {
                        targetQty = tier1Qty;
                    }
                    const progress = targetQty ? Math.min((eligibleCount / targetQty) * 100, 100) : 0;
                    mobileProgressBar.style.width = `${progress}%`;
                }
            }

            if (mobileDiscount) {
                if (isSubscription && subDiscountPercent > 0 && eligibleCents > 0) {
                    mobileDiscount.textContent = `Συνδρομή: -${subDiscountPercent}%`;
                    mobileDiscount.style.color = 'var(--mm-accent)';
                    mobileDiscount.style.fontWeight = 'bold';
                } else if (discount > 0 && eligibleCents > 0) {
                    const tierPercent = Math.round((discount / eligibleCents) * 100);
                    mobileDiscount.textContent = `Κέρδος: -${tierPercent}%`;
                    mobileDiscount.style.color = '#2c9f45';
                    mobileDiscount.style.fontWeight = 'bold';
                } else {
                    mobileDiscount.textContent = '';
                }
            }

            if (freeShippingMsg) {
                if (totalCount === 0) {
                    freeShippingMsg.style.display = 'none';
                } else if (freeShippingThreshold > 0) {
                    const remainingForShipping = freeShippingThreshold - finalTotal;
                    freeShippingMsg.style.display = 'flex';
                    const span = freeShippingMsg.querySelector('span');
                    if (span) {
                        if (remainingForShipping > 0) {
                            span.textContent = `Προσθέστε ${formatMoney(remainingForShipping)} για δωρεάν μεταφορικά`;
                        } else {
                            span.textContent = 'Δωρεάν μεταφορικά!';
                        }
                    }
                } else {
                    freeShippingMsg.style.display = 'flex';
                }
            }

            if (mobileShipping) {
                if (totalCount === 0) {
                    mobileShipping.textContent = '';
                } else if (freeShippingThreshold > 0) {
                    const remainingForShipping = freeShippingThreshold - finalTotal;
                    mobileShipping.textContent = remainingForShipping > 0
                        ? `-${formatMoney(remainingForShipping)} μεταφορικά`
                        : 'Δωρεάν μεταφορικά';
                } else {
                    mobileShipping.textContent = '';
                }
            }

            // Exclusions Logic: Disable subscription if only excluded items are in bundle
            const onlyExcludedItems = totalCount > 0 && eligibleCount === 0;
            const subOption = document.querySelector('.js-purchase-option[data-type="subscription"]');

            if (subOption) {
                if (onlyExcludedItems) {
                    subOption.classList.add('disabled');
                    if (isSubscription) {
                        isSubscription = false;
                        const oneTimeOption = document.querySelector('.js-purchase-option[data-type="onetime"]');
                        if (oneTimeOption) {
                            purchaseOptions.forEach(opt => opt.classList.remove('active'));
                            oneTimeOption.classList.add('active');
                            setTimeout(() => updateUI(), 0);
                        }
                    }
                } else {
                    subOption.classList.remove('disabled');
                }
            }
        }

        // Purchase Option Toggle
        purchaseOptions.forEach(option => {
            option.addEventListener('click', function () {
                if (this.classList.contains('disabled')) return;

                purchaseOptions.forEach(opt => opt.classList.remove('active'));
                this.classList.add('active');

                const type = this.getAttribute('data-type');
                isSubscription = (type === 'subscription');
                updateUI();
            });
        });

        // Quick View Logic
        const modalOverlay = document.querySelector('.js-modal-overlay');
        const modalCloseBtn = document.querySelector('.js-close-modal');
        const modalImage = document.querySelector('.js-modal-image');
        const modalTitle = document.querySelector('.js-modal-title');
        const modalPrice = document.querySelector('.js-modal-price');
        const modalDesc = document.querySelector('.js-modal-desc');

        function openModal(data) {
            if (!modalImage || !modalTitle || !modalPrice || !modalDesc || !modalOverlay) return;

            modalImage.src = data.image;
            modalTitle.textContent = data.title;
            modalPrice.textContent = data.price;
            modalDesc.innerHTML = data.description;

            modalOverlay.classList.add('active');
            document.body.style.overflow = 'hidden';
        }

        function closeModal() {
            if (modalOverlay) modalOverlay.classList.remove('active');
            document.body.style.overflow = '';
        }

        if (modalCloseBtn) {
            modalCloseBtn.addEventListener('click', closeModal);
        }

        if (modalOverlay) {
            modalOverlay.addEventListener('click', function (e) {
                if (e.target === modalOverlay) {
                    closeModal();
                }
            });
        }

        // Sidebar Remove Item Event Delegation
        if (bundleItemsContainer) {
            bundleItemsContainer.addEventListener('click', function (e) {
                const removeBtn = e.target.closest('.js-remove-sidebar-item');
                if (removeBtn) {
                    const variantId = removeBtn.getAttribute('data-variant-id');
                    if (bundleState[variantId]) {
                        delete bundleState[variantId];
                        updateUI();
                    }
                }
            });
        }

        // Event Delegation
        productsContainer.addEventListener('click', function (e) {
            // Handle Quick View Click
            const quickViewBtn = e.target.closest('.js-quick-view');
            if (quickViewBtn) {
                e.preventDefault();
                e.stopPropagation();

                const data = {
                    title: quickViewBtn.getAttribute('data-product-title'),
                    description: quickViewBtn.getAttribute('data-product-description'),
                    image: quickViewBtn.getAttribute('data-product-image'),
                    price: quickViewBtn.getAttribute('data-product-price')
                };
                openModal(data);
                return;
            }

            // Handle Collection Header Click
            const header = e.target.closest('.js-collection-header');
            if (header) {
                header.classList.toggle('active');
                const content = header.nextElementSibling;
                if (content && content.classList.contains('js-collection-content')) {
                    content.classList.toggle('active');
                }
                return;
            }

            const actionEl = e.target.closest('.mix-match-actions');
            if (!actionEl) return;

            const variantId = actionEl.getAttribute('data-variant-id');
            const price = parseInt(actionEl.getAttribute('data-price'));
            const title = actionEl.getAttribute('data-title');
            const image = actionEl.getAttribute('data-image');
            const excluded = actionEl.getAttribute('data-excluded') === 'true';
            const sellingPlanId = actionEl.getAttribute('data-selling-plan-id');

            const addBtn = e.target.closest('.js-add-to-bundle');
            const plusBtn = e.target.closest('.js-qty-plus');

            if (addBtn || plusBtn) {
                if (!bundleState[variantId]) {
                    const row = actionEl.closest('.mix-match-row');
                    let iconHtml = '';
                    let iconBg = '';

                    if (row) {
                        const iconEl = row.querySelector('.mix-match-row-icon');
                        if (iconEl) {
                            iconBg = iconEl.style.backgroundColor || '';

                            if (iconEl.tagName === 'IMG') {
                                iconHtml = iconEl.outerHTML;
                            } else {
                                iconHtml = iconEl.innerHTML;
                            }
                        }
                    }

                    bundleState[variantId] = { variantId, price, title, image, sellingPlanId, excluded, qty: 0, iconHtml, iconBg };
                }
                bundleState[variantId].qty++;
                updateUI();
            }

            if (e.target.classList.contains('js-qty-minus')) {
                if (bundleState[variantId] && bundleState[variantId].qty > 0) {
                    bundleState[variantId].qty--;
                    if (bundleState[variantId].qty === 0) {
                        delete bundleState[variantId];
                    }
                    updateUI();
                }
            }
        });

        // Checkout Logic
        if (checkoutBtn) {
            checkoutBtn.addEventListener('click', function () {
                const itemsToAdd = Object.values(bundleState).map(item => {
                    const payload = {
                        id: item.variantId,
                        quantity: item.qty
                    };

                    if (isSubscription && item.sellingPlanId && !item.excluded) {
                        payload.selling_plan = item.sellingPlanId;
                    }

                    return payload;
                });

                if (itemsToAdd.length === 0) return;

                checkoutBtn.classList.add('loading');
                checkoutBtn.textContent = 'Προσθήκη...';

                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ items: itemsToAdd })
                })
                    .then(response => response.json())
                    .then(data => {
                        // Shopify cart/add.js does NOT reject the fetch promise on
                        // validation errors (e.g. out of stock, invalid selling plan) —
                        // it returns a 200-shaped JSON body with a "status" field instead.
                        // We must check for that explicitly, or a failed add silently
                        // continues to the next step and redirects to an unchanged
                        // (possibly empty) cart.
                        if (data.status && data.status !== 200) {
                            throw new Error(data.description || data.message || 'Cart add failed');
                        }

                        return fetch(window.Shopify.routes.root + 'cart.js');
                    })
                    .then(response => response.json())
                    .then(cart => {
                        document.dispatchEvent(new CustomEvent('cart:update', {
                            bubbles: true,
                            detail: {
                                cart: cart,
                                data: {
                                    itemCount: cart.item_count
                                }
                            }
                        }));

                        window.location.href = `${window.Shopify.routes.root}cart`;
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        checkoutBtn.classList.remove('loading');
                        checkoutBtn.textContent = 'Κάποιο προϊόν εξαντλήθηκε. Ελέγξτε το πακέτο σας.';

                        setTimeout(() => {
                            checkoutBtn.textContent = 'Προσθήκη στο καλάθι';
                        }, 4000);
                    });
            });
        }

        // Initial render
        updateUI();
    }

    // Run immediately if ready (Theme Editor re-render case), else wait for DOM
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initMixMatch);
    } else {
        initMixMatch();
    }
})();